module.exports = __webpack_public_path__ + "img/csm_white.08d94736.svg";